import { render, staticRenderFns } from "./PlanejamentoContratoFormAcoesCamposComuns.vue?vue&type=template&id=5e84674b"
import script from "./PlanejamentoContratoFormAcoesCamposComuns.vue?vue&type=script&lang=js"
export * from "./PlanejamentoContratoFormAcoesCamposComuns.vue?vue&type=script&lang=js"
import style0 from "./PlanejamentoContratoFormAcoesCamposComuns.vue?vue&type=style&index=0&id=5e84674b&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports